import Vue from 'vue';

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    // eslint-disable-next-line no-param-reassign
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.value.method](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  update(el, binding) {
    if (binding.value.loading) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
    } else {
      document.body.addEventListener('click', el.clickOutsideEvent);
    }
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});



// WEBPACK FOOTER //
// ./src/directives/index.js